(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["km-measurement-form"] && !Shopify.designMode) return;
  try {
    function kmRequestPrefill(){const value=new URLSearchParams(location.search).get('product');if(value)document.querySelectorAll('[data-km-request-product]').forEach(input=>{if(!input.value)input.value=value.slice(0,250)});}
kmRequestPrefill();document.addEventListener('shopify:section:load',kmRequestPrefill);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["km-standard-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('km-door-fillings')) {
    customElements.define('km-door-fillings', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const initialize = () => {
          if (!this.isConnected || signal.aborted) return;
          for (const details of this.querySelectorAll('.kmsp-door-choice')) {
            if (!details.hasAttribute('data-ready')) {
              details.open = details.hasAttribute('data-first-door');
              details.setAttribute('data-ready', '');
            }
            this.updateChoice(details);
          }
        };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', initialize, { once: true, signal });
        } else {
          initialize();
        }
        this.addEventListener('change', (event) => {
          if (!event.target.matches('[data-door-filling], [data-door-division]')) return;
          this.updateChoice(event.target.closest('.kmsp-door-choice'));
        }, { signal });
        this.addEventListener('invalid', (event) => {
          const details = event.target.closest('.kmsp-door-choice');
          if (details) details.open = true;
        }, { capture: true, signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
      updateChoice(details) {
        const selected = details.querySelector('[data-door-filling]:checked');
        const label = details.querySelector('[data-selected-label]');
        const division = details.querySelector('[data-door-division]:checked');
        if (label) {
          label.textContent = [selected?.value || label.dataset.placeholder, division?.getAttribute('aria-label')].filter(Boolean).join(' · ');
        }
        const customColor = details.querySelector('[data-custom-color]');
        if (customColor) {
          customColor.disabled = selected?.value !== 'Farge spektrum';
          customColor.required = !customColor.disabled;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
